// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"02ada08e6257138c3c11","269":"594275b246825c71e3c4","525":"5972a1c443e3d9c1204b"}[chunkId] + ".css";
};